import dayjs from 'dayjs';

export function formatTimestamp(timestamp: string): string {
  const dateObj = new Date(timestamp);
  return dateObj.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatTimestampIntoRelativeDate(timestamp: string): string {
  const now = dayjs();
  const date = dayjs(timestamp);
  const daysDifference = now.diff(date, 'day');
  const hoursDifference = now.diff(date, 'hour');

  if (hoursDifference < 24) {
    if (hoursDifference < 1) {
      const minutesDifference = now.diff(date, 'minute');

      if (minutesDifference === 0) {
        return 'a few seconds ago';
      }

      return `${minutesDifference} minutes ago`;
    }

    return `${hoursDifference} hours ago`;
  }

  if (daysDifference === 1) {
    return 'Yesterday';
  }

  if (daysDifference < 7) {
    return `${daysDifference} days ago`;
  }

  return date.format('MM/DD/YYYY');
}
